import { useState } from 'react';
import { BarChart3, ChevronDown, ChevronUp, SlidersHorizontal } from 'lucide-react';
import { useDashboardStore } from '@/stores/dashboardStore';
import { formatFilters, activeFilterCount } from '@/utils/formatters';
import FilterPanel from './FilterPanel';

export default function Header() {
  const [open, setOpen] = useState(false);
  const { globalPeriod, filters } = useDashboardStore();
  const filterCount = activeFilterCount(filters);

  return (
    <header className="header">
      <div className="header-top">
        <div className="logo">
          <div className="logo-icon">
            <BarChart3 size={20} />
          </div>
          <div>
            <div className="title">中顺洁柔终端每日过程管理看板</div>
            <div className="subtitle">
              {[globalPeriod, `筛选：${formatFilters(filters)}`].filter(Boolean).join(' | ')}
            </div>
          </div>
        </div>
        <button className="filter-toggle" onClick={() => setOpen(!open)}>
          <SlidersHorizontal size={14} />
          <span className="filter-toggle-text">筛选器</span>
          {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
          {filterCount > 0 && <span className="filter-toggle-badge">{filterCount}</span>}
        </button>
      </div>
      <FilterPanel open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
